
import eventFire from "./eventFire";
document.addEventListener('DOMContentLoaded', () => {

    // header
    let pageScrollOffset = 300
    window.addEventListener("scroll", () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let h = document.querySelector(".b-header")
      if (scrollTop > pageScrollOffset && !h.classList.contains('b-header--scrolled')) {
          h.classList.add('b-header--scrolled');
      }
      if (scrollTop <= pageScrollOffset){
          h.classList.remove('b-header--scrolled');
      }
    });
    eventFire(window,'scroll');

})

